export const USER_LIST = "user_list";
export const USER_DELETE = "user_delete";
export const USER_SET_ACCEPTED = "user_set_accepted";
